import { render, staticRenderFns } from "./ProjectSearchBarWithFilter.vue?vue&type=template&id=56461ff4&scoped=true&"
import script from "./ProjectSearchBarWithFilter.vue?vue&type=script&lang=js&"
export * from "./ProjectSearchBarWithFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56461ff4",
  null
  
)

export default component.exports